
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.25 7.188L8.796 11.64M8.813 7.188l4.453 4.453M1.492 4.414l2.273 1.988 3.374-4.591","stroke":"#545C69","stroke-width":"1.208","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    